export default "__VITE_ASSET__vLfngkVT__"